import React from 'react'
import styled from "styled-components"
import media from "styled-media-query"

const RecordTable = ({records}) => {

   const renderList = records.map((rec, i) => {

      return (
         <tr key={i}>
            <td>{rec.school}</td>
            <td>{rec.record}</td>
         </tr>
      )
   })

   return (
      <RecordTableStyles >
         <div className="table-wrap">
            <table>
               <thead>
                  <tr>
                     <th>学校名</th>
                     <th>人数</th>
                  </tr>
               </thead>
               <tbody>
                  {renderList}
               </tbody>
            </table>
         </div>
      </RecordTableStyles>
   )
}

const RecordTableStyles = styled.section`
   margin: 50px 0;
   .table-wrap {
      width: 80%;
      margin: 0 auto;
      ${media.lessThan("600px")`
         width: 95%;
      `}
   }
   
   table {
      width: 100%;
      thead {
         width: 100%;
         background-color: #FF3D01;
         tr {
            height: 40px;
            line-height: 40px;
            font-size: 2.5rem;
            color: #fff;
            ${media.lessThan("960px")`
               height: 35px;
               line-height: 35px;
               font-size: 2rem;
            `}
            th {
               &:first-child {
                  width: 70%;
               }
               &:last-child {
                  width: 30%;
               }
            }
         }
      }
      tbody {
         tr {
            width: 100%;
            height: 40px;
            font-size: 2.5rem;
            line-height: 40px;
            text-align: center;
            border: 1px solid #D3D3D3;
            color: #6E6E6E;
            ${media.lessThan("960px")`
               height: 35px;
               line-height: 35px;
               font-size: 2rem;
            `}
            td {
               width: 50%;
               &:first-child {
                  border-right: 1px solid #D3D3D3;
               }
            }
         }
      }
   }
`

export default RecordTable